export default __webpack_public_path__ + "static/media/img1.254c223a.jpg";